/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import _ from "lodash";
import axios from "../../../api/axiosService";
import { getLocalized } from "../../../Common/Util";

export default function Schedule({ ...props }) {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState({});

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `/api/schedule/list?artistId=${props.id}`,
      );
      const generatedData = groupObjectsByWeek(response.data.data);
      setData(generatedData);
    } catch (error) {
      console.error("Error fetching data: ", error);
      // Xử lý lỗi tại đây
    }
  };

  useEffect(() => {
    if (props.id) fetchData();
  }, []);

  function groupObjectsByWeek(items) {
    const groups = {};

    items.forEach((item) => {
      const [date, month, year] = item.date.split("/").map(Number);
      const dateObj = new Date(year, month - 1, date);
      item.date = dateObj;

      // Tính ngày thứ hai đầu tuần (theo ISO)
      const day = dateObj.getDay(); // 0 (Sunday) -> 6 (Saturday)
      const diff = day === 0 ? -6 : 1 - day; // nếu là Chủ nhật thì lùi về thứ 2 trước
      const monday = new Date(dateObj);
      monday.setDate(dateObj.getDate() + diff);
      monday.setHours(0, 0, 0, 0);

      const key = monday.toISOString(); // YYYY-MM-DD

      if (!groups[key]) {
        groups[key] = {
          month: convertTime(item.date, "month"),
          year: convertTime(item.date, "year"),
          schedule: [],
        };
      }
      groups[key].schedule.push({
        ...item,
        date: convertTime(item.date, "date"),
      });
    });

    // Convert object to two-dimensional arrays
    const groupedArray = Object.values(groups);
    return groupedArray;
  }

  const convertTime = (dateData, field) => {
    const isoDate = dateData;
    const date = new Date(isoDate);
    if (field === "month") {
      const month = date.toLocaleString("en-US", { month: "long" }); // "March"
      return month;
    }

    if (field === "year") {
      const year = date.getFullYear(); // 2025
      return year;
    }

    if (field === "date") {
      // Weekday map
      const weekdays = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
      // Get 2-letter weekday and day
      const shortWeekday = weekdays[date.getUTCDay()]; // use getDay() if you want local time
      const day = date.getUTCDate(); // or date.getDate()

      const formatted = `${shortWeekday}. ${day}`;
      return formatted;
    }
  };

  return (
    <div className="schedule-tab">
      {_.isObject(data) && (
        <div className="content">
          <div className="schedule-list">
            {data?.length > 0 &&
              data.map((week, index) => (
                <div key={index} className="schedule-week">
                  <div className="title">
                    <span className="month">{week.month}</span>
                    <span className="year">{week.year}</span>
                  </div>
                  {week.schedule.map((value, idx) => (
                    <div key={idx}>
                      <hr className="divider" />
                      <div className="schedule-item">
                        <div className="datetime">{value.date}</div>
                        <div className="info">
                          <div className="name title-2">
                            {getLocalized(value, "name", i18n.language)}
                          </div>
                          <div className="location normal-text">
                            {getLocalized(value, "location", i18n.language)}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

// const DATA = [
//   {
//     id: "61ab39bdd4607e001d53bd2f",
//     date: "2025-03-14T11:13:12.026Z",
//     name: "CONCERT \n ANH TRAI VƯỢT NGÀN CHÔNG GAI",
//     location: "Global City, Phường An Phú, Quận 2, thành phố Thủ Đức"
//   },
//   {
//     id: "61ab39bdd4607e001d53bd4f",
//     date: "2025-03-17T11:13:12.026Z",
//     name: "CONCERT ANH TRAI VƯỢT NGÀN CHÔNG GAI",
//     location: "Global City, Phường An Phú, Quận 2, thành phố Thủ Đức"
//   },
//   {
//     id: "61ab39bdd4607e001d53bd3f",
//     date: "2025-03-25T11:13:12.026Z",
//     name: "CONCERT ANH TRAI VƯỢT NGÀN CHÔNG GAI",
//     location: "Global City, Phường An Phú, Quận 2, thành phố Thủ Đức"
//   },
//   {
//     id: "61ab39bdd4607e001d53bd1f",
//     date: "2025-03-26T11:13:12.026Z",
//     name: "CONCERT ANH TRAI VƯỢT NGÀN CHÔNG GAI",
//     location: "Global City, Phường An Phú, Quận 2, thành phố Thủ Đức"
//   },
// ];
